import React, { useEffect } from 'react'
import { CustomDataTable } from '../../../../../components'
import { Column } from 'primereact/column'
import { connect } from 'react-redux'

import { CustomModal, CustomCheckbox, InputText, CustomDataTableHeader } from '../../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import useModalAssocEnterprise, { LOAD_MESSAGE } from './ModalAssocEmpresaHook'

function ModalAssocEmpresa({ dispatch, show, onModalClose, customer }) {
  const { state, localDispatch } = useModalAssocEnterprise()

  useEffect(() => {
    if (show) localDispatch.onInit(customer)
  }, [customer, show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.INITIAL_CHECK:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.getCustomerCompaniesAssociaton(
          state.customer ? state.customer.id : state.customer,
        )
        break

      case LOAD_MESSAGE.SWITCH_ASSOC:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.switchCustomerAssociationWithTP(state.association)
        break

      default:
        break
    }
  }, [state.loadingMessage, state.customer])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <CustomModal
      header={`Associação: ${state.customer ? state.customer.nomeFantasia : ''}`}
      isVisible={show}
      onClose={onModalClose}
      width={600}
    >
      <CustomDataTable
        value={state.associations}
        paginator={true}
        rows={5}
        header={
          <CustomDataTableHeader
            value={state.globalFilter}
            onChange={value => localDispatch.onChange('globalFilter', value)}
          />
        }
        globalFilter={state.globalFilter}
      >
        <Column
          field="actived"
          header=""
          style={{ textAlign: 'center', width: 100 }}
          body={association => (
            <CustomCheckbox
              checked={association.actived}
              onChange={() => localDispatch.onCheckBoxClicked(association)}
            />
          )}
        />
        <Column field="company_name" header="Empresa" />
        <Column
          field="company_code"
          header="Cód. Cliente Empresa"
          body={association => (
            <InputText
              autoComplete="some-value"
              marginTop={0}
              showLabel={false}
              value={association.company_code}
              onChange={value => localDispatch.onCompanyClientCodeChange(association, value)}
            />
          )}
        />
      </CustomDataTable>
    </CustomModal>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(ModalAssocEmpresa)
